import Table from 'components/table/table';
import MediaQuery from 'react-responsive';
import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import EmptyState from '../../../components/EmptyState/EmptyState';
import TimeSheetMobileCard from '../../../components/card/MobileListCard/TimeSheetMobileCard';
import UseContext from '../../../hooks/useContext';

const ToBeCompletedContent = () => {
  const {
    timeSheetsToDisplay,
    currentPage,
    setCurrentPage,
    totalPages,
    countPerPage,
    countTotal,
    isWaiting,
    setStatus,
  } = useOutletContext();
  const { setObjID, setContent } = UseContext();
  const navigate = useNavigate();

  useEffect(() => {
    setStatus('0');
  }, [setStatus]);

  const handleTimeSheetClick = (item) => {
    setObjID(item._id);
    setContent({
      title: item.title,
      idMission: item.id_mission_reel,
      nameCompany: item.name_commercial,
    });

    const currentUrl = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.set('id', item._id);
    window.history.replaceState({}, '', `${currentUrl}?${params.toString()}`);

    navigate(`../ficheHour/${item._id}`);
  };

  // Skeleton pour les cartes mobiles
  const MobileCardSkeleton = () => (
    <div className="flex flex-col gap-3 p-4 animate-pulse">
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="bg-white rounded-xl border border-gray-200 p-4">
          <div className="flex justify-between items-start mb-3">
            <div className="h-5 bg-gray-200 rounded w-3/4"></div>
            <div className="h-6 bg-gray-100 rounded-md w-16"></div>
          </div>
          <div className="flex justify-between items-center gap-4">
            <div className="h-4 bg-gray-100 rounded w-24"></div>
            <div className="h-4 bg-gray-100 rounded w-28"></div>
            <div className="h-4 bg-gray-100 rounded w-32"></div>
          </div>
        </div>
      ))}
    </div>
  );

  const titles = [
    'N° DE RELEVÉ',
    'RAISON SOCIALE',
    'POSTE',
    'N° DE MISSION',
    'INTÉRIMAIRE',
    'PÉRIODE',
  ];

  return (
    <div className={'flex flex-col h-full'}>
      {isWaiting ? (
        <>
          {/* Skeleton desktop */}
          <MediaQuery minWidth={768}>
            <table className="animate-pulse w-full">
              <tbody>
                {[1, 2, 3, 4, 5].map((i, index) => (
                  <tr key={index}>
                    {titles?.map((title, idx) => (
                      <td key={idx} className={`py-7 ${idx === 0 ? 'pl-4' : ''} ${idx === titles.length - 1 ? 'pr-3' : 'px-2'}`}>
                        <div className="h-2 bg-gray-200 rounded"></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </MediaQuery>
          {/* Skeleton mobile */}
          <MediaQuery maxWidth={767}>
            <MobileCardSkeleton />
          </MediaQuery>
        </>
      ) : (
        <>
          {timeSheetsToDisplay?.length > 0 ? (
            <>
              {/* Vue desktop - Table */}
              <MediaQuery minWidth={768}>
                <Table
                  champsBody={timeSheetsToDisplay}
                  champsHeader={titles}
                  currentPage={currentPage}
                  countPerPage={countPerPage}
                  countTotal={countTotal}
                  totalPages={totalPages}
                  setCurrentPage={setCurrentPage}
                />
              </MediaQuery>
              
              {/* Vue mobile - Cartes */}
              <MediaQuery maxWidth={767}>
                <div className="flex flex-col gap-3 p-4">
                  {timeSheetsToDisplay.map((item) => (
                    <TimeSheetMobileCard
                      key={item._id}
                      item={item}
                      onClick={handleTimeSheetClick}
                    />
                  ))}
                </div>
              </MediaQuery>
            </>
          ) : (
            <div className="p-3">
              <EmptyState type={'time_sheet_check'} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ToBeCompletedContent;
